export default __webpack_public_path__ + "static/media/1920 cutlery top.a688476c.png";